<div class="creatcustom">
  <div class="customerDetails">
    <div class="customerheader">
      <i class="icon-person_add-F iconsize"></i>

      <h4 class="newcustomer">{{ "ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.NewCustomer" | translate }}</h4>
      <ssg-button (click)="stateChange()" icon="icon-west-o" class="exit"></ssg-button>
    </div>
    <hr />
    <form [formGroup]="group">
      <div class="infohead">
        <i class="icon-person_outline-F iconsize"></i>
        <h4>{{ "ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.HeaderTitle" | translate }}</h4>
      </div>
      <div class="infobox">
        <ssg-input
          class="info"
          (OnEnter)="submit()"
          [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.FirstName' | translate"
          [group]="group"
          name="FirstName"></ssg-input>
        <ssg-input
          [required]="true"
          class="info"
          (OnEnter)="submit()"
          [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.LastName' | translate"
          [group]="group"
          name="LastName"></ssg-input>
        <ssg-input
          [required]="true"
          class="info"
          (OnEnter)="submit()"
          [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.Number' | translate"
          [group]="group"
          name="Number"></ssg-input>
        <ssg-select
          name="Title"
          [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.Title' | translate"
          [searchable]="false"
          apiName="Branch/ReadTitles"
          class="info"
          [group]="group"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
        <ssg-select
          name="PersonalityKindId"
          [searchable]="false"
          [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.PersonalityKindId' | translate"
          [dataList]="personalityKind"
          class="info"
          [group]="group"
          [required]="true"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
        <ssg-select
          name="CategoryId"
          [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.CategoryId' | translate"
          [searchable]="false"
          class="info"
          [dataList]="customerCategory"
          [group]="group"
          [required]="true"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
        <ssg-select
          name="Gender"
          [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.Gender' | translate"
          apiName="Lookup"
          [searchable]="false"
          class="info"
          [group]="group"
          systemName="GNR"
          [required]="true"
          category="Gender"
          textFieldName="Title"
          valueFieldName="Id">
        </ssg-select>
      </div>
      <div></div>
      <div class="infohead">
        <i class="icon-home_work-o iconsize"></i>
        <h4>{{ "ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.Region" | translate }}</h4>
      </div>
      <div class="rentgroup">
        <ssg-select
          name="ZoneId"
          [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.Region' | translate"
          [dataList]="zone"
          class="rent"
          [group]="group"
          [required]="false"
          textFieldName="Title"
          (valueChange)="onChanged($event)"
          valueFieldName="Id">
        </ssg-select>

        <ssg-input
          class="rent"
          (OnEnter)="submit()"
          [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.Rent' | translate"
          [group]="group"
          name="ShippingCost"
          textType="number"></ssg-input>
      </div>
      <hr class="line" />
      <div class="form">
        <div class="infohead">
          <i class="icon-location_on-o iconsize"></i>
          <h4>{{ "ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.Address" | translate }}</h4>
        </div>
        <div class="addres">
          <ssg-input
            [required]="true"
            class="address"
            [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.Address' | translate"
            [group]="group"
            name="Addresses"></ssg-input>
        </div>
        <div class="grouptel" *ngIf="customer.Addresses && customer.Addresses.length > 1">
          <div class="customtel" *ngFor="let address of customer.Addresses; let inde = index">
            <div *ngIf="inde !== 0">
              <input type="radio" name="customerinfo" class="radio" />
              <div>
                <label>{{ "ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.Address" | translate }} : </label>
                <span>{{ address.Address }}</span>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="infohead" (click)="ShowAddressDialog()">
          <ssg-button label="افزودن" icon="icon-add-o" class="addbtn"></ssg-button>
        </div>-->
      </div>
      <hr class="line" />
      <div class="form">
        <div class="infohead">
          <i class="icon-call-o iconsize"></i>
          <h4>{{ "ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.Phone" | translate }}</h4>
        </div>
        <div class="infobox">
          <div class="info">
            <ssg-select
              name="NumberTypeId"
              [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.NumberTypeId' | translate"
              apiName="Lookup"
              class="telgroup"
              [group]="group"
              systemName="SALE"
              [required]="true"
              (valueChange)="onNumberTypeChanged($event)"
              category="NumberType"
              textFieldName="Title">
            </ssg-select>
          </div>
          <div class="info" *ngIf="numbersVisibility">
            <ssg-input
              class="tel"
              [required]="true"
              [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.Numbers' | translate"
              [group]="customerOrder.group"
              name="Numbers"
              textType="text"></ssg-input>
          </div>
          <div class="grouptel" *ngIf="customer.Numbers && customer.Numbers.length > 0">
            <div class="customtel" *ngFor="let number of customer.Numbers">
              <!--<input type="radio" name="customerinfo" class="radio">-->
              <div class="customer-title">
                <label>{{ "ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.Phone" | translate }} : </label>
                <span>{{ number.Number }}</span>
              </div>
              <span class="icon" (click)="DeleteSelectedPhone(number)">
                <i class="icon-cancel-circle garsonicon"></i>
              </span>
            </div>
          </div>
        </div>
        <!-- <div class="infohead">
          <ssg-button [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.New'| translate" icon="icon-add-o" class="addbtn" (click)="ShowPhoneDialog()"></ssg-button>
        
        </div> -->
        <div class="addbtn" (click)="ShowPhoneDialog()">
          <i class="icon-add-o"></i>
          <span>{{ "ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.New" | translate }}</span>
        </div>
      </div>
      <div class="recordbtn">
        <ssg-button
          [label]="'ClientApp.FrontOffice.Order.CustomerOrder.NewCustomerOrder.Save' | translate"
          buttontype="submit"
          (click)="submit()"></ssg-button>
      </div>
    </form>
  </div>
</div>
